import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_search_filter_number_range extends PureComponent {
  render() {
    return (
      <div className="row" id="component_search_filter_number_range">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Search Filter Number Range</h2>
              <p>
                Filter number range gives the user the ability to restrict a
                results component to a number range on a particular field. The
                number range filter supports both “greater than” and “less than”
                as well as “between”.
              </p>
              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={true}
              />
              <InterfaceProperties
                type={"search_filter_number_range"}
                name={"filter number range"}
                dataNameDefault={
                  '"long_my_field" or "object_my_obj.long_my_field"'
                }
                searchGroup={true}
                padding={true}
                hide={true}
                order={true}
                tabIndex={true}
                displayName={true}
                properties={[
                  {
                    property: "decimals",
                    description:
                      'Numbers including decimals are stored in the database as whole numbers. This feature converts whole numbers to decimals. A value of 0 will treat the value as a whole number a value of 2 will divide number by 100 and show two decimals. This will only work with data_type "number".',
                    defaults: '0-32 default is 0'
                  },
                  {
                    property: "default_greater_than",
                    description:
                      'Set the default greater than value.',
                    defaults: '0-4,294,967,295 default is none'
                  },
                  {
                    property: "default_less_than",
                    description:
                      'Set the default less than value.',
                    defaults: '0-4,294,967,295 default is none'
                  },
                  {
                    property: "value_prefix",
                    description:
                      'Set the display value prefix.',
                    defaults: '"$", "£", "€" default is ""'
                  },
                  {
                    property: "value_suffix",
                    description:
                      'Set the display value suffix.',
                    defaults: '"%", "cm", "km" default is ""'
                  },
                ]}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Search Filter Number Range Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Filter Number Range</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"search_filter_number_range"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">
                    "long_my_number"
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My number"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_group"</span>:{" "}
                  <span className="jsonY">"record_results_1"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Filter Currency Range</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"search_filter_number_range"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">
                    "long_price"
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"Price"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_group"</span>:{" "}
                  <span className="jsonY">"record_results_1"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"value_prefix"</span>:{" "}
                  <span className="jsonY">"$"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"decimals"</span>:{" "}
                  <span className="jsonP">2</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"default_less_than"</span>:{" "}
                  <span className="jsonP">200</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_search_filter_number_range;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_search_filter_number_range.js